import React, { useState } from "react";
import { TAnimationVariant } from "../LandingSectionBase";
import ProductDetailsCustomBox, {
  ImageByLocation,
} from "../../../../Core/ProductDetails/ProductDetailsImages/ProductDetailsCustomBox/ProductDetailsCustomBox";

import { getCustomBoxTileBaseSize } from "../../../../Core/ProductDetails/ProductDetailsImages/ProductDetailsCustomBox/ProductDetailsCustomBox.config";
import { LandingAnimatedBound } from "./LandingAnimatedImage.styled";
import useInterval from "./unseInterval";
import saintValentinTemplate from "./images/saintValentinTemplate";

interface ILandingAnimationImageProps {
  variant?: TAnimationVariant;
  style?: React.CSSProperties;
}

const LandingAnimatedImage = (props: ILandingAnimationImageProps) => {
  const { variant, style } = props;
  const animationList = variant === "st-valentin" ? saintValentinTemplate : [];
  const [imageByLocation, setImageByLocation] = useState<ImageByLocation>();
  const [frame, setFrame] = useState(0);

  useInterval(() => {
    setImageByLocation((c) => ({
      ...c,
      ...animationList[frame],
    }));
    setFrame((frame + 1) % animationList.length);
  }, 1000);

  return (
    <div style={style}>
      <ProductDetailsCustomBox
        // debug={true}
        style={{ background: "transparent" }}
        baseImage={""}
        imageByLocation={imageByLocation}
        renderItem={({ image, bound, location, bId, parentSize }) => {
          const { type, o } = location;
          const { style } = bound;
          const baseType = type.replace(/\-div$/, "") as typeof type;
          const { w: baseW, h: baseH } = getCustomBoxTileBaseSize(baseType);
          let w = o === "h" ? baseH : baseW,
            h = o === "h" ? baseW : baseH,
            isDivided = /\-div$/.test(type);
          if (isDivided) {
            w = w / 2;
          }
          return (
            <LandingAnimatedBound
              type="button"
              key={bId}
              className="sidedish-custom-box__location__bounds"
              data-bid={bId}
              $w={(w * parentSize) / 800}
              $h={(h * parentSize) / 800}
              $sourceImage={image}
              style={{
                ...style,
              }}
            ></LandingAnimatedBound>
          );
        }}
      />
    </div>
  );
};

export default LandingAnimatedImage;
